import { render, staticRenderFns } from "./allotMenu.vue?vue&type=template&id=3f1c1da2&scoped=true"
import script from "./allotMenu.vue?vue&type=script&lang=js"
export * from "./allotMenu.vue?vue&type=script&lang=js"
import style0 from "./allotMenu.vue?vue&type=style&index=0&id=3f1c1da2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1c1da2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f1c1da2')) {
      api.createRecord('3f1c1da2', component.options)
    } else {
      api.reload('3f1c1da2', component.options)
    }
    module.hot.accept("./allotMenu.vue?vue&type=template&id=3f1c1da2&scoped=true", function () {
      api.rerender('3f1c1da2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/user/role/allotMenu.vue"
export default component.exports